<!-- <p>test-distribution works!</p> -->
<app-dialog-header headerText="Test Asset Model: {{selectedAsset.Name}} - {{selectedAsset.Description}}"
    headerIcon="science" (onCloseClick)="onCancelClick()"></app-dialog-header>
<div class="main-div">
    <div *ngIf="!AdvancedTest" class="menu alignRow alignColumn">
        <div class="days-select alignRow">
            <span [ngStyle]="{'color': !DateRangeSelected ? 'lightgray': ''}">Select Date Range:</span>
            <button mat-raised-button [matMenuTriggerFor]="timeMenu" #timeTrigger="matMenuTrigger" [disabled]="!DateRangeSelected">
                <span>Date Range</span>
                <mat-icon>access_time</mat-icon>
            </button>
            <mat-menu #timeMenu="matMenu">
                <div style="margin: 1em;">
                    <app-date-range-picker (datePickerChange)="dateRangeSelected($event)"
                        [matMenuTrigger]="timeTrigger"></app-date-range-picker>
                </div>
            </mat-menu>
        </div>
        <!-- <span class="alignColumn">OR</span> -->
        <div class="switch alignRow">
            <span class="app-icon app-icon--left" (click)="changeOption(true)"
                [ngStyle]="{'color': DateRangeSelected ? 'lightgray': '', 'cursor': DateRangeSelected ? '' : 'pointer'}">
                <mat-icon />
            </span>
            <span>OR</span>
            <span class="app-icon app-icon--right" (click)="changeOption(false)"
                [ngStyle]="{'color': !DateRangeSelected ? 'lightgray': '', 'cursor': !DateRangeSelected ? '' : 'pointer'}">
                <mat-icon />
            </span>
        </div>
        <div class="days-select alignRow">
            <span [ngStyle]="{'color': DateRangeSelected ? 'lightgray': ''}">Select Days to Test:</span>
            <ejs-numerictextbox [step]="1" cssClass="e-custom" max="365" min="1" [(value)]="numDays" [decimals]="0"
                [enabled]="!DateRangeSelected">
            </ejs-numerictextbox>
        </div>
    </div>
    <div *ngIf="AdvancedTest" class="menu-advanced alignRow alignColumn">
        <div class="alignRow" style="margin: auto;">
            <button mat-raised-button [matMenuTriggerFor]="timeMenuAdvanced">
                <span>Start Date</span>
                <mat-icon>access_time</mat-icon>
            </button>
            <mat-menu #timeMenuAdvanced="matMenu">
                <div style="margin: 1em;">
                    <ejs-datepicker placeholder="Start Date" [firstDayOfWeek]="0" format="dd-MM-yyyy"
                        [dayHeaderFormat]="'Abbreviated'" [max]="earliestDate" (change)="selectStartDate($event)">
                    </ejs-datepicker>
                </div>
            </mat-menu>
        </div>
        <div class="days-select alignRow" style="margin: auto;">
            <span>Weeks to Test:</span>
            <ejs-numerictextbox (change)="onNumDaysChange($event)" [step]="1" cssClass="e-custom" [max]="maxWeeks"
                min="5" [(value)]="numWeeks" [decimals]="0">
            </ejs-numerictextbox>
        </div>
        <div class="slide-toggle alignRow">
            <mat-slide-toggle color="primary" [checked]="treatAsAutomatic" (change)="toggleTreatAsAuto($event)">Treat as
                Automatic</mat-slide-toggle>
            <mat-icon style="cursor: pointer; margin-left: 5px;" [matMenuTriggerFor]="treatAsAutoHelp">help</mat-icon>
            <mat-menu #treatAsAutoHelp>
                <div style="padding: 0.5em;">
                    <span>With 'Treat as Automatic' enabled the model will be recreated on previous data after a set
                        number of days tested.<br><br></span>
                    <span>The number of days between the model being recreated is defined by Recreation Frequency
                        option.<br><br></span>
                    <span>The Overlap Period defines how many days of data is shared from one model to the
                        next.<br></span>
                </div>
            </mat-menu>
        </div>
        <div class="days-select alignRow">
            <span>Recreation Frequency</span>
            <ejs-numerictextbox [step]="1" cssClass="e-custom" [(value)]="recreationFrequency" [decimals]="0"
                [enabled]="treatAsAutomatic">
            </ejs-numerictextbox>
        </div>
        <div class="days-select alignRow">
            <span>Overlap Period</span>
            <ejs-numerictextbox [step]="1" cssClass="e-custom" [(value)]="overlapPeriod" [decimals]="0"
                [enabled]="treatAsAutomatic">
            </ejs-numerictextbox>
        </div>
    </div>
    <div class="alignColumn alignRow" class="start-button">
        <span style="margin: auto; font-weight: bolder; font-style: italic;">{{validRangeSelected ? getSelectedRange() :
            AdvancedStart > 0 ? getDateWithoutTime(AdvancedStart) : ""}}</span>
        <button style="margin: auto;" mat-raised-button
            (click)="!AdvancedTest ? testDistribution() : testDistributionAuto()" style="margin: auto;">
            <span>Test Model</span>
            <mat-icon>play_arrow</mat-icon>
        </button>
        <div class="slide-toggle alignRow">
            <mat-slide-toggle color="primary" (change)="toggleAdvancedTest($event)">Advanced Test</mat-slide-toggle>
            <mat-icon style="cursor: pointer; margin-left: 5px;" [matMenuTriggerFor]="advancedHelp">help</mat-icon>
            <mat-menu #advancedHelp>
                <div style="padding: 0.5em;">
                    <span>An 'Advanced Test' tests the model over a period of historical data, checking one week at a
                        time.<br></span>
                </div>
            </mat-menu>
        </div>
    </div>
    <div class="local-spinner" *ngIf="spinner">
        <img src="https://stmgwebappstorage.blob.core.windows.net/prismpdm/assets/loading.gif"
            [attr.x-contenttype]="'image/gif'" alt="Loading..." />
    </div>
    <div class="columns" *ngIf="!AdvancedTest">
        <div class="test-result alignColumn alignRow" *ngIf="DatapointZScores.length > 0">
            <div class="datapoint-item alignColumn alignRow" style="width: 100%;"
                *ngFor="let item of allInfo, index as i">
                <span *ngIf="distribution.Sensitivity == 50" style="font-weight: bolder; text-align: center;">
                    {{item.DatapointZScore.Datapoint.DPTitle}} had an average Z-Score of
                    {{item.DatapointZScore.ZScore.toFixed(2)}}.
                </span>
                <span *ngIf="distribution.Sensitivity != 50" style="font-weight: bolder; text-align: center;">
                    {{item.percentage.percentageAbove.toFixed(2)}}% of values for
                    {{item.DatapointZScore.Datapoint.DPTitle}}
                    had a
                    Z-Score above the Tolerance of {{distribution.Tolerance}} with an average Z-Score of
                    {{item.percentage.ZScore.toFixed(2)}}.
                </span>
                <div *ngIf="(distribution.Sensitivity == 50 && (item.DatapointZScore.ZScore > 1 && item.DatapointZScore.ZScore < 3)) 
                        || (distribution.Sensitivity != 50 && (item.percentage.ZScore > 1 && item.percentage.ZScore < 3))"
                    class="alignColumn">
                    <span style="font-style: italic;">This is <b>high</b> and indicates an increase in the DataPoint's
                        values compared to the model.</span>
                    <br>
                    <span style="text-align: center;">It is recommended is to investigate the Asset to see whether the
                        values in the selected range are normal. If the values <b>are normal</b> then the model may need
                        updating.</span>
                </div>
                <div *ngIf="(distribution.Sensitivity == 50 && item.DatapointZScore.ZScore >= 3)
                        || (distribution.Sensitivity != 50 && item.percentage.ZScore >= 3)" class="alignColumn">
                    <span style="font-style: italic;">This is <b>very high</b> and indicates a severe increase in the
                        DataPoint's values compared to the model.</span>
                    <br>
                    <span style="text-align: center;">It is recommended is to investigate the Asset promptly to see
                        whether
                        the values in the selected range are normal. If the values <b>are normal</b> then the model may
                        need
                        updating. Otherwise action may need to be taken to reduce the DataPoint's values.</span>
                </div>
                <div *ngIf="(distribution.Sensitivity == 50 && (item.DatapointZScore.ZScore < -1 && item.DatapointZScore.ZScore > -3)) 
                        || (distribution.Sensitivity != 50 && (item.percentage.ZScore < -1 && item.percentage.ZScore > -3))"
                    class="alignColumn">
                    <span style="font-style: italic;">This is <b>low</b> and indicates a decrease in the DataPoint's
                        values compared to the model.</span>
                    <br>
                    <span style="text-align: center;">It is recommended is to investigate the Asset to see whether
                        the values in the selected range are normal. If the values <b>are normal</b> then the model may
                        need
                        updating.</span>
                </div>
                <div *ngIf="(distribution.Sensitivity == 50 && item.DatapointZScore.ZScore <= -3)
                        || (distribution.Sensitivity != 50 && item.percentage.ZScore <= -3)" class="alignColumn">
                    <span style="font-style: italic;">This is <b>very low</b> and indicates a severe decrease in the
                        DataPoint's values compared to the model.</span>
                    <br>
                    <span style="text-align: center;">It is recommended is to investigate the Asset to see whether
                        the values in the selected range are normal. If the values <b>are normal</b> then the model may
                        need
                        updating.</span>
                    <!-- Otherwise action may need to be taken to increase the DataPoint's values. -->
                </div>
                <div *ngIf="(distribution.Sensitivity == 50 && (item.DatapointZScore.ZScore < 1 && item.DatapointZScore.ZScore > -1)) 
                        || (distribution.Sensitivity != 50 && (item.percentage.ZScore < 1 && item.percentage.ZScore > -1))"
                    class="alignColumn">
                    <span style="font-style: italic;">This is an <b>ideal score</b> and indicates the data fits the
                        model
                        well.</span>
                    <br>
                    <span style="text-align: center;">The values in the selected range match the values used to create
                        the
                        model, so nothing needs to be done. The model will be able to accurately detect any abnormal
                        values
                        in the future.</span>
                </div>
                <div *ngIf="distribution.Sensitivity == 50 && (item.DatapointZScore.ZScore > distribution.Tolerance)">
                    <br>
                    <span style="font-style: italic; text-align: center;">
                        With this model this DataPoint <b>would have</b> created an Event if checked using this test
                        data.
                    </span>
                </div>
                <div
                    *ngIf="distribution.Sensitivity != 50 && (item.percentage.percentageAbove > (100 - distribution.Sensitivity))">
                    <br>
                    <span style="font-style: italic; text-align: center;">
                        With this model this DataPoint <b>would have</b> created an Event if checked using this test
                        data.
                    </span>
                </div>
                <hr *ngIf="i < DatapointZScores.length - 1" style="margin-top: 1em; margin-bottom: 1em; width: 100%;">
            </div>
        </div>
        <div *ngIf="testImage.length > 0 && !AdvancedTest" class="image-div">
            <img style="max-height: 60vh; max-width: 100%;" [src]="'data:image/png;base64,' + testImage"
                alt="Distribution Image" />
        </div>
    </div>
    <div class="columns2" *ngIf="AdvancedTest">
        <div *ngIf="usingAverage" style="max-width: 100%;">
            <div *ngFor="let item of sparkLineData">
                <div class="sparkline_1 alignRow">
                    <div class="alignColumn">
                        <div class="double_grid alignColumn">
                            <span>DataPoint:</span>
                            <span><b>{{item.DPTitle}}</b></span>
                        </div>
                    </div>
                    <figure class="alignColumn">
                        <ejs-sparkline [id]="'Sparkline_' + item.DatapointID" #sparkline height="75px" width="205px"
                            lineWidth="2" valueType="Category" fill="#3C78EF" [dataSource]="item.Values" xName="xval"
                            yName="yval" format='n' [tooltipSettings]="SparkLineTooltipSettings"
                            [axisSettings]="axisSettings"
                            [rangeBandSettings]="[{startRange: 0, endRange: distribution.Tolerance, color: '#bfd4fc'}]">
                        </ejs-sparkline>
                        <figcaption>{{item.GraphTitle}}</figcaption>
                    </figure>
                </div>
            </div>
        </div>
        <div *ngIf="!usingAverage" style="max-width: 100%;">
            <div *ngFor="let item of sparklineDoubleData">
                <div class="sparkline_2 alignRow">
                    <div class="alignColumn">
                        <div class="double_grid alignColumn">
                            <span>DataPoint:</span>
                            <span><b>{{item[0].DPTitle}}</b></span>
                        </div>
                    </div>
                    <figure class="alignColumn">
                        <ejs-sparkline [id]="'Sparkline_' + item[0].DatapointID" #sparkline height="75px" width="205px"
                            lineWidth="2" valueType="Category" fill="#3C78EF" [dataSource]="item[0].Values" xName="xval"
                            yName="yval" format='n' [tooltipSettings]="SparkLineTooltipSettings"
                            [axisSettings]="axisSettings"
                            [rangeBandSettings]="[{startRange: 0, endRange: (100 - distribution.Sensitivity), color: '#bfd4fc'}]">
                        </ejs-sparkline>
                        <figcaption>{{item[0].GraphTitle}}</figcaption>
                    </figure>
                    <figure class="alignColumn">
                        <ejs-sparkline [id]="'Sparkline2_' + item[0].DatapointID" #sparkline height="75px" width="205px"
                            lineWidth="2" valueType="Category" fill="#3C78EF" [dataSource]="item[1].Values" xName="xval"
                            yName="yval" format='n' [tooltipSettings]="SparkLineTooltipSettings"
                            [axisSettings]="axisSettings">
                        </ejs-sparkline>
                        <figcaption>{{item[1].GraphTitle}}</figcaption>
                    </figure>
                    <figure class="alignColumn">
                        <ejs-sparkline [id]="'Sparkline3_' + item[2].DatapointID" #sparkline height="75px" width="205px"
                            lineWidth="2" valueType="Category" fill="#3C78EF" [dataSource]="item[2].Values" xName="xval"
                            yName="yval" format='n' [tooltipSettings]="SparkLineTooltipSettings"
                            [axisSettings]="axisSettings"
                            [rangeBandSettings]="[{startRange: 0, endRange: distribution.Tolerance, color: '#bfd4fc'}]">
                        </ejs-sparkline>
                        <figcaption>{{item[2].GraphTitle}}</figcaption>
                    </figure>
                </div>
            </div>
        </div>
        <div *ngIf="AdvancedTest && AutoResult.length > 0" class="carousel-div">
            <div style="display: flex; margin-bottom: 0.5em;">
                <div class="slide-toggle alignRow" style="margin: 0; margin-right: 1em;">
                    <mat-slide-toggle color="primary" [checked]="autoplay"
                        (change)="toggleAutoplay($event)">Autoplay</mat-slide-toggle>
                </div>
                <div class="week-select alignRow" style="margin: 0;">
                    <span>Go to week:</span>
                    <ejs-numerictextbox [step]="1" cssClass="e-custom" [max]="numWeeks" min="1" [decimals]="0"
                        (change)="goToWeek($event)">
                    </ejs-numerictextbox>
                </div>
            </div>
            <ejs-carousel #carousel cssClass="default-carousel" indicatorsType="Progress" [autoPlay]="false"
                [buttonsVisibility]="'VisibleOnHover'" [nextButtonTemplate]="nextButtonTemplate" [autoPlay]="autoplay"
                [previousButtonTemplate]="previousButtonTemplate" width="62vw" [selectedIndex]="selectedCarouselIndex">
                <ng-template #nextButtonTemplate let-data>
                    <button mat-icon-button>
                        <mat-icon>chevron_right</mat-icon>
                    </button>
                </ng-template>
                <ng-template #previousButtonTemplate let-data>
                    <button mat-icon-button>
                        <mat-icon>chevron_left</mat-icon>
                    </button>
                </ng-template>
                <e-carousel-items>
                    <e-carousel-item *ngFor="let result of AutoResult, index as index">
                        <ng-template #template>
                            <div class="columns">
                                <div class="test-result">
                                    <span style="font-weight: bold; font-size: large;" class="alignRow alignColumn">Week
                                        {{index + 1}}</span>
                                    <div class="datapoint-item alignColumn" style="width: 100%;"
                                        *ngFor="let item of result, index as i">
                                        <span *ngIf="distribution.Sensitivity == 50"
                                            style="font-weight: bolder; text-align: center;">
                                            {{item.DatapointZScore.Datapoint.DPTitle}} had an average Z-Score of
                                            {{item.DatapointZScore.ZScore.toFixed(2)}}.
                                        </span>
                                        <span *ngIf="distribution.Sensitivity != 50"
                                            style="font-weight: bolder; text-align: center;">
                                            {{item.percentage.percentageAbove.toFixed(2)}}% of values for
                                            {{item.DatapointZScore.Datapoint.DPTitle}} had a Z-Score above
                                            the Tolerance of {{distribution.Tolerance}} with an average
                                            Z-Score of {{item.percentage.ZScore.toFixed(2)}}.
                                        </span>
                                        <div *ngIf="(distribution.Sensitivity == 50 && (item.DatapointZScore.ZScore > 1 && item.DatapointZScore.ZScore < 3)) 
                        || (distribution.Sensitivity != 50 && (item.percentage.ZScore > 1 && item.percentage.ZScore < 3))"
                                            class="alignColumn">
                                            <span style="font-style: italic;">This is <b>high</b> and indicates an
                                                increase in the DataPoint's values compared to the model.</span>
                                            <br>
                                            <span style="text-align: center;">It is recommended is to investigate the
                                                Asset to see whether the values in the selected range are normal.
                                                If the values <b>are normal</b> then the model may need updating.</span>
                                        </div>
                                        <div *ngIf="(distribution.Sensitivity == 50 && item.DatapointZScore.ZScore >= 3)
                        || (distribution.Sensitivity != 50 && item.percentage.ZScore >= 3)" class="alignColumn">
                                            <span style="font-style: italic;">This is <b>very high</b> and indicates a
                                                severe increase in the DataPoint's values compared to the model.</span>
                                            <br>
                                            <span style="text-align: center;">It is recommended is to investigate the
                                                Asset promptly to see whether the values in the selected range are
                                                normal. If the values <b>are normal</b> then the model may need
                                                updating. Otherwise action may need to be taken to reduce the
                                                DataPoint's values.</span>
                                        </div>
                                        <div *ngIf="(distribution.Sensitivity == 50 && (item.DatapointZScore.ZScore < -1 && item.DatapointZScore.ZScore > -3)) 
                        || (distribution.Sensitivity != 50 && (item.percentage.ZScore < -1 && item.percentage.ZScore > -3))"
                                            class="alignColumn">
                                            <span style="font-style: italic;">This is <b>low</b> and indicates a
                                                decrease in the DataPoint's values compared to the model.</span>
                                            <br>
                                            <span style="text-align: center;">It is recommended is to investigate the
                                                Asset to see whether the values in the selected range are normal.
                                                If the values <b>are normal</b> then the model may need updating.</span>
                                        </div>
                                        <div *ngIf="(distribution.Sensitivity == 50 && item.DatapointZScore.ZScore <= -3)
                        || (distribution.Sensitivity != 50 && item.percentage.ZScore <= -3)" class="alignColumn">
                                            <span style="font-style: italic;">This is <b>very low</b> and indicates a
                                                severe decrease in the DataPoint's values compared to the model.</span>
                                            <br>
                                            <span style="text-align: center;">It is recommended is to investigate the
                                                Asset to see whether the values in the selected range are normal.
                                                If the values <b>are normal</b> then the model may need updating.</span>
                                        </div>
                                        <div *ngIf="(distribution.Sensitivity == 50 && (item.DatapointZScore.ZScore < 1 && item.DatapointZScore.ZScore > -1)) 
                        || (distribution.Sensitivity != 50 && (item.percentage.ZScore < 1 && item.percentage.ZScore > -1))"
                                            class="alignColumn">
                                            <span style="font-style: italic;">This is an <b>ideal score</b> and
                                                indicates the data fits the model well.</span>
                                            <br>
                                            <span style="text-align: center;">The values in the selected range match the
                                                values used to create the model, so nothing needs to be done.
                                                The model will be able to accurately detect any abnormal values
                                                in the future.</span>
                                        </div>
                                        <div
                                            *ngIf="distribution.Sensitivity == 50 && (item.DatapointZScore.ZScore > distribution.Tolerance)">
                                            <br>
                                            <span style="font-style: italic; text-align: center;">
                                                With this model this DataPoint <b>would have</b> created an Event if
                                                checked using this test data.
                                            </span>
                                        </div>
                                        <div
                                            *ngIf="distribution.Sensitivity != 50 && (item.percentage.percentageAbove > (100 - distribution.Sensitivity))">
                                            <br>
                                            <span style="font-style: italic; text-align: center;">
                                                With this model this DataPoint <b>would have</b> created an Event if
                                                checked using this test data.
                                            </span>
                                        </div>
                                        <hr *ngIf="i < result.length - 1"
                                            style="margin-top: 1em; margin-bottom: 1em; width: 100%;">
                                    </div>
                                </div>
                                <!-- style="padding: 3em;" -->
                                <div class="image-div">
                                    <img [src]="'data:image/png;base64,' + result[0].Image"
                                        style="height:100%;width:100%;" />
                                </div>
                            </div>
                        </ng-template>
                    </e-carousel-item>
                </e-carousel-items>
            </ejs-carousel>
        </div>
    </div>
</div>